<template lang="pug">
el-container.main
    .main-header
        .main-breadcrumb
            span.bcb 成员列表
        .main-action
            el-button(type="primary", size="small", @click="show('memberFormVisible')") 创建
    template(v-if="members.length === 0")
        .main-content
            .block
                span 尚无成员
    template(v-else)
        .main-content
            el-table(v-bind:data="members" :header-cell-style="tableHeaderColor")
                el-table-column(prop="user.name" label="账号")
                el-table-column(prop="user.displayName", label="展示名")
                el-table-column(prop="orgRole" label="组织角色" width="120" :formatter="displayRoleCNName")
                el-table-column(prop="user.email", label="邮箱")
                el-table-column(label="操作" width="180")
                    template(slot-scope="scope")
                        el-button(type="text", @click="editMember(scope.row)") 编辑
                        el-button(type="text", @click="editPasswordReset(scope.row.user)") 重置密码
                        el-button(type="text", @click="deleteOrgMember(scope.row.user.name)") 删除
        .main-pager
            el-pagination.page(background, layout='prev, pager, next', :page-count='page.total', :current-page='page.number', @current-change='currentChange')

    CreateEdit(:memberFormVisible="display.memberFormVisible" :editingMember="editingMember" :orgname="org.name" @hideMemberForm="hideMemberForm" @refreshMembers="refreshMembers")
    PasswordReset(:passwordResetFormVisible="display.passwordResetFormVisible" :editingMember="editingMember" :orgname="org.name" @hidePasswordResetForm="hidePasswordResetForm")
</template>

<script>
// @ is an alias to /src
import {
  getUserOrgsAPI,
  listOrgMembersAPI,
  deleteOrgMemberAPI
} from '@/services'
import CreateEdit from './CreateEdit.vue'
import PasswordReset from './PasswordReset.vue'

export default {
  name: 'Member',
  components: { CreateEdit, PasswordReset },
  data() {
    return {
      loading: false,
      page: {
        total: 1,
        number: 1
      },
      org: {},
      members: [],
      editingMember: null,
      display: {
        memberFormVisible: false,
        passwordResetFormVisible: false
      }
    }
  },
  methods: {
    /**
         * Backend Service API Function Wrapper
         */
    // TODO more accurate info on orgs.length === 0
    async listOrgMembers() {
      this.loading = true
      try {
        const res1 = await getUserOrgsAPI({
          name: localStorage.getItem('account')
        })
        if (res1.status === 200 && res1.data.length) {
          this.org = Object.assign({}, res1.data[0].org)
        } else if (res1.status === 200 && res1.data.length === 0) {
          return
        } else {
          throw new Error('组织列表为空')
        }
        const res2 = await listOrgMembersAPI(this.org.name, {
          number: this.page.number
        })
        if (res2.status === 200) {
          this.members = res2.data.data
          this.page = {
            total: res2.data.total,
            number: res2.data.number
          }
        }
      } catch (err) {
        console.log(err)
        this.$message.error('服务器开小差了，请尝试重新操作')
      } finally {
        this.loading = false
      }
    },
    async deleteOrgMember(username) {
      this.loading = true
      try {
        const res = await deleteOrgMemberAPI(this.org.name, username)
        if (res.status === 204) {
          this.$message('删除成功')
          this.refreshMembers()
        }
      } catch (err) {
        this.$message.error('服务器开小差了，请尝试重新操作')
      } finally {
        this.loading = false
      }
    },
    /**
         * UI Interaction
         */
    show(name) {
      this.display[name] = true
    },
    hide(name) {
      this.display[name] = false
    },
    refreshMembers() {
      this.listOrgMembers()
    },
    hideMemberForm() {
      this.hide('memberFormVisible')
      this.editingMember = null
    },
    hidePasswordResetForm() {
      this.hide('passwordResetFormVisible')
      this.editingMember = null
    },
    editMember(row) {
      this.show('memberFormVisible')
      this.editingMember = Object.assign({}, row.user, {
        orgRole: row.orgRole
      })
    },
    editPasswordReset(member) {
      this.show('passwordResetFormVisible')
      this.editingMember = member
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f2f2f2;color: #8493A8;'
      }
    },
    currentChange(number) {
      this.page.number = number
      this.listOrgMembers()
    },
    displayRoleCNName(row) {
      if (row.orgRole === 'owner') {
        return '所有人'
      } else if (row.orgRole === 'admin') {
        return '管理员'
      } else if (row.orgRole === 'member') {
        return '普通成员'
      } else {
        return row.orgRole
      }
    }
  },
  mounted() {
    this.listOrgMembers()
  }
}
</script>
<style lang="stylus" scoped>
.block {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 10px;
  padding: 20px;
  border: dashed 1px #bbbbbb;
  border-radius: 15px;

  span {
    margin: auto;
  }

  .el-input {
    width: 360px;
  }
}
</style>
